import { barChartScale } from './bar_chart';
import { lineChartScale } from './line_chart';
import { scatterChartScale } from './scatter_bubble_chart';

const SCALE_FUNCTIONS = {
  BarChart: barChartScale,
  LineChart: lineChartScale,
  ScatterPlot: scatterChartScale,
  ScatterBubblePlot: scatterChartScale,
};

export function computeScales({
  chartType,
  data,
  getConfiguration,
  meta,
  width,
  height,
}) {
  const scaleFn = SCALE_FUNCTIONS[chartType];

  if (scaleFn) {
    return scaleFn({ data, getConfiguration, meta, width, height });
  } else {
    // error message
  }
}
